module.exports = __webpack_public_path__ + "img/entrance_full.0fa38832.jpg";